<template>
  <section class="grid-flex column">
    <div class="flex-1 flex row w100 middle">
      <div class="box">
        <div class="box-content">
          <div class="flex row middle">
            <div class="flex-2">
              <div class="flex">
                <div class="flex-1">
                  Saldo liberado para saque: 
                  <div class="margin-top-s">
                    <h2>{{ report.mycredit_to_withdraw | money  }}</h2>  
                  </div>
                </div>
                <div class="flex-1">
                  Saldo a liberar: 
                  <div class="margin-top-s">
                    <h2>{{ report.mycredit_to_be_released | money  }}</h2>  
                  </div>
                </div>
              </div>
              <div class="margin-top-l">
                <small>
                  Valor minímo para saque: <b>R$ 50,00</b>
                </small>
              </div>
              <div class="">
                <small><b>Saldo liberado para saque</b>: Somatório das comissões referente a vendas com mais de <b>30 dias</b>.</small>
              </div>
              <div class="">
                <small><b>São a Liberar</b>: referente a vendas com menos de <b>30 dias</b>.</small>
              </div>

              <div class="margin-topl-">
                <small>
                  Após a solicitação de saque, a trasferência será efetuada em até <b>3 dias úteis</b>.
                </small>
              </div>
            </div>
            
            <div class="flex-1 my-action">
              <div class="flex end">
                <a @click="openModal()">
                  <div class="button primary" :class="{disabled: !enableWithDraw}">SOLICITAR SAQUE</div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="flex-1 flex row w100 middle">
      <div class="flex-1 no-mobile">
        <h3>Histórico de Saques</h3>
      </div>
      <div class="flex-1 ">
        <!-- pagination -->
        <div class=" w100 end filters-groupo-holder flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :click-handler="clickCallback"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
      </div>
    </div>

    <div class="mobile">
        <h3>Histórico de Saques</h3>
    </div>

    <div class="flex-1 w100 margin-to-l">
      <ul>
        <li v-for="(wdraw, index) in withdraws" :key="index">
          <div class="box margin-top-m">
            <div class="box-content">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s">
                      <p>
                        {{ wdraw.id | number }} - Solicitação de Saque
                      </p>
                      <div class="flex column">
                        <div><small>PIX</small></div>
                      </div>
                    </div>
                    <div class="flex-2 margin-top-s">
                      <div class="flex details between">
                        <div class="status">
                          <p>Status</p>
                          <small 
                            :class="{ 
                              approved: wdraw.status === 'DONE',
                              failed: wdraw.status !== 'DONE' && wdraw.status !== 'AWAITG'
                            }"
                          >
                            {{ _decode_status(wdraw.status) }}</small>
                        </div>
                        <div>
                          <p>Valor</p>
                          <small
                            class="commission"
                            :class="{ 
                              approved: wdraw.status === 'DONE',
                              failed: wdraw.status !== 'DONE' && wdraw.status !== 'AWAITG'
                            }"
                          >
                            {{ wdraw.value | money}}
                            <div class="no-value"></div>
                          </small>
                        </div>
                        <div>
                          <p>Solicitado:</p>
                          <small> {{ wdraw.created_at | date }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <div class="flex end">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="isEmpty" class="box center-text margin-top-l">
        <div class="box-content">
          <p>
            Não encontramos nenhum saque. Assim que você realizar seu primeiro saque ele irá aprecer nesta lista.
          </p>
        </div>
      </div>

      <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <!-- pagination -->
      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
              <paginate
                :containerClass="'pagination'"
                :page-count="totalPages"
                v-model="page"
                :page-range="5"
                :click-handler="clickCallback"
                :prev-text="'Anterior'"
                :next-text="'Próxima'"
              ></paginate>
            </div>
        </div>
      </div>
    </div>

    <!-- modals -->
    <new-witdraw
      :show="showModal"
      :maxValue="valueMaxLimit"
      @close="
        showModal = false;
      "
      @accept="newWithDraw($event)"
    ></new-witdraw>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { 
  getWithdraws,
  createWithdraw,
  removeWithdraw
} from "@/services/withdraw";


import NewWitdraw from "./New";

const emptyData = {
  mycredit_to_be_released: '-',
  mycredit_to_withdraw: '-',
}

export default {
  name: "automation",
  components: { 
    NewWitdraw
  },
  data() {
    return {
      showModal: false,
      minValue: 50,
      newWitdraw: {
        value: 0
      },
      loading: false,
      filters: {
        data: {},
        list: {},
      },
      report: Object.assign({}, emptyData),
      withdraws: [],
      totalWithdraw: 1,
      offset: 10,
      page: 1,
    };
  },
  mounted() {
    this.getWithdraws();
  },
  computed: {
    valueMaxLimit() {
      return this.report.mycredit_to_withdraw || 0 
    },
    isEmpty() {
      return this.totalWithdraw === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalWithdraw % this.offset;
      let value = this.totalWithdraw / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    enableWithDraw(){
      return this.valueMaxLimit >= this.minValue
    },
  },
  watch: {
    "page": {
      handler() {
        this._reset_info()
        this.getWithdraws();
      }
    }
  },
  methods: {
    _reset_info() {
      this.withdraws = [];
      this.report = Object.assign({}, emptyData)
    },
    _decode_status(status) {
      let _map = {
        'DONE': 'PAGO',
        'REJECT': 'REJEITADO',
        'AWAITG': 'AGUARDANDO',
      }

      return _map[status] || status
    },
    openModal() {
      if (this.enableWithDraw) {
        this.showModal = true
      } else {
        this.$toast.error({
          title:'Erro',
          message:`Você não tem saldo suficiênte para solicitar saque. Valor minímo de R$ ${this.minValue},00`
        })
      }
    },
    newWithDraw(data) {
      this.createWithdraw(data.value)
    },
    removeWithdraw(withdraw_id) {

      removeWithdraw(withdraw_id)
        .then(() => {
          this.withdraws = this.withdraws.filters(e => e.id !== withdraw_id)
          this.$toast.success({
            title:'Sucesso',
            message:'Saque removido com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema ao remover saque'
          })
        })
    },
    createWithdraw(value) {
      let params = {
        value: value
      }
      createWithdraw(params)
        .then(() => {
          // update saldo
          this._reset_info()
          this.getWithdraws()

          this.$toast.success({
            title:'Sucesso',
            message:'Saque criado com sucesso'
          })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema ao criar saque'
          })
        })
        .finally(() => {
          this.showModal = false
        })
    },
    getWithdraws() {
      this.loading = true;
      let params = {
        page: this.page,
        offset: this.offset,
      };
      getWithdraws(params)
        .then((result) => {
          this.withdraws = result.withdraws.map((p) => {
            return {
              id: p.id,
              name: p.name,
              value: p.value,
              status: p.status,
              type: p.type,
              created_at: p.created_at,
            };
          });
          this.totalWithdraw = result.total
          this.report = result.report
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar saques",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.details {
  > div {
    margin-right: 34px;
    p {
      line-height: 20px;
    }
    small {
      font-weight: 800;
    }
  }
}

.name {
  small {
    font-weight: 800;
  }
}

.profit {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
}

@media screen and (max-width: 1024px) {

  .details {
    flex-direction: column;

    > div {
      margin-right: 8px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      p::after {
        content: ':'
      }
      small {
        margin-left: 8px;
      }
    }

  }
  .action {
    margin-top: 16px;
  }

}

.status {
  max-width: 50px;
}


.approved {
  color: green;
}

.failed {
  color: red;
}

.no-value {
  display: none;
}

.commission {
  position: relative;
  &.failed { 
    .no-value {
      display: inline;
      position: absolute;
      width: 100px;
      border-bottom: 2px solid red;
      top: 7px;
      left: -14px;
      // transform: rotate(-15deg); /* Equal to rotateZ(45deg) */
    }
  }
}

.disabled {
  background: #c2c2c2 !important;
}
@media screen and (max-width: 1024px) {
  .my-action {
    margin-top: 16px;
    .end {
      align-content: start;
      align-items: start;
      justify-content: start;
    }

  }

}

</style>
